import {Injectable, Renderer2, RendererFactory2} from '@angular/core';
import { AllService } from './all.service';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { AndroidInterface } from '../types/all.type';
import { SnotifyPosition, SnotifyService } from 'ng-snotify';
import { log } from '../functions';
import { MusicPlayerService } from './music-player.service';
import {InterfaceService} from './interface.service';
import {DcService} from './dc.service';
declare const customTitlebar: any;
declare const Android: AndroidInterface;
@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private initSystemDarkMode = false;
  public renderer: Renderer2;
  public blur = 5;
  public backgroundThemeList: any = [
    {
      src: '/assets/images/bg.jpg',
      active: false
    },
    {
      src: '/assets/images/bg2.jpg',
      active: false
    },
    {
      src: '/assets/images/bg3.jpg',
      active: false
    },
    {
      src: '/assets/images/bg4.jpg',
      active: false
    },
    {
      src: '/assets/images/bg5.jpg',
      active: false
    },
    {
      src: '/assets/images/bg6.png',
      active: false
    }
  ];
  public backgroundThemeActive;
  constructor(
    private dcService: DcService,
    private snotifyService: SnotifyService,
    private _renderer: RendererFactory2,
    public allService: AllService
  ) {
    this.renderer = _renderer.createRenderer(null, null);
    this.backgroundThemeList = this.allService.getVarLocal('theme-images', this.backgroundThemeList);
    setInterval(() => {
      if (this.backgroundThemeList?.findIndex((v) => v.active) > -1) {
        this.backgroundThemeActive++;

        if (this.backgroundThemeActive >= 0) {
          this.backgroundThemeActive = 0;
        }
        this.dcService.detectChanges$.next('app-root');
      }
    }, 60000);

    this.backgroundThemeActive = this.activeBackgroundList?.findIndex((v) => v.active);
  }
  get activeBackground(): any {
    return this.backgroundThemeActive ? this.backgroundThemeList[this.backgroundThemeActive] : false;
  }
  set activeBackground(index) {
    this.backgroundThemeList[index].active = !this.backgroundThemeList[index].active;
    if(this.backgroundThemeList[index].active) {
      this.backgroundThemeActive = index;
    }else{
      this.backgroundThemeActive = this.backgroundThemeList.findIndex((v) => v.active);
    }
    this.saveImagesList();
    this.changeTheme();
    this.changeCompact();
    if(this.activeBackgroundList?.length === 0) {
      this.backgroundThemeActive = -1;
      this.backgroundThemeList.map((v) => v.active = false);
      this.saveImagesList();
    }
    setTimeout(() => {
      this.changeTheme();
      this.dcService.detectChanges$.next('app-root');
    }, 10);
  }
  get activeBackgroundList(): any {
    return this.backgroundThemeList.filter((v) => v.active);
  }
  saveImagesList() {
    this.allService.setVarLocal('theme-images', this.backgroundThemeList);
  }

  handleChangeImage(info: { file: NzUploadFile }): void {
    log(info);
    switch (info.file.type) {
      case 'start':
        // Get this url from response in real world.
        this.backgroundThemeList.push({
          src: info.file?.src,
          active: true
        });
        this.saveImagesList();
        break;
    }
  }
  changeCompact(init = false) {
    if (this.compact) {
      this.renderer.addClass(document.body, 'theme-compact');
    } else {
      this.renderer.removeClass(document.body, 'theme-compact');
    }
  }
  changeTheme(init = false) {
    //alert(this.getStatusBarHeight());
    let theme: string = localStorage.getItem('theme');
    try {
      if (init && Android.getDefaultNightMode() === 1) {
        theme = 'dark';
        this.initSystemDarkMode = true;
      }
    } catch (e) {
      //alert(e);
    }
    if (customTitlebar) {
      this.renderer.addClass(document.body, 'custom-navbar');
    }
    if (this.backgroundThemeActive < 0) {
      this.renderer.removeClass(document.body, 'theme-image');
    } else {
      this.renderer.addClass(document.body, 'theme-image');
    }
    if (typeof theme === 'string') {
      const theme: string = localStorage.getItem('theme');
      switch (theme) {
        case 'dark':
          // this.musicPlayerService.wrapPlayer.playerTheme = PlayerThemeDark;
          this.clearLightStatusBar();
          this.changeStatusBarColor('#121212');
          this.renderer.addClass(document.body, 'theme-' + theme);
          //electronTitle.updateBackground(new customTitlebar.Color(new customTitlebar.RGBA(0, 0, 0, .7)));
          break;
        default:
          // this.musicPlayerService.wrapPlayer.playerTheme = PlayerThemeLight;
          this.renderer.removeClass(document.body, 'theme-dark');
          this.setLightStatusBar();
          this.changeStatusBarColor('#ffffff');
          //electronTitle.updateBackground(new customTitlebar.Color(new customTitlebar.RGBA(255, 255, 255, .7)));
          break;
      }
    }
  }
  setBrowserThemeColor(color: string): void {
    try {
      const metaThemeColor = document.querySelector('meta[name=theme-color]');
      metaThemeColor.setAttribute('content', color);
    } catch (e) {}
  }
  setLightStatusBar() {
    try {
      //.setStatusBarColor();
      Android.setLightStatusBar();
    } catch (e) {}
    this.setBrowserThemeColor('#edeef6');
  }
  clearLightStatusBar() {
    try {
      //.setStatusBarColor();
      Android.clearLightStatusBar();
    } catch (e) {}
    this.setBrowserThemeColor('#1d1d1d');
  }
  changeStatusBarColor(color: string) {
    try {
      //.setStatusBarColor();
      Android.changeStatusBarColor(color);
    } catch (e) {}
  }
  getStatusBarHeight() {
    try {
      //.setStatusBarColor();
      return Android.getStatusBarHeight();
    } catch (e) {
      return 0;
    }
  }
  set theme(val) {
    this.initSystemDarkMode = false;
    const theme = val ? 'dark' : '';
    localStorage.setItem('theme', theme);
    this.changeTheme();
  }
  get theme() {
    if (this.initSystemDarkMode) return 'dark';
    return localStorage.getItem('theme');
  }
  set compact(val) {
    const compact = val ? 'Y' : 'N';
    localStorage.setItem('compact', compact);
    this.changeCompact();
  }
  get compact() {
    return localStorage.getItem('compact') === 'Y';
  }
  set systemTitleBar(val) {
    localStorage.setItem('systemTitleBar', val ? 'Y' : 'N');
    const electron = window?.require('electron');
    electron.ipcRenderer.send('title.bar', val);
    this.snotifyService.clear();
    this.snotifyService.confirm('Title Bar изменится после перезапруска приложения', '', {
      timeout: 30000,
      showProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      type: 'success',
      position: SnotifyPosition.centerTop,
      buttons: [
        {
          text: 'Перезапустить',
          action: () => {
            electron.ipcRenderer.send('restart', val);
          },
          bold: false
        },
        { text: 'Позже', action: () => log('Clicked: No') }
      ]
    });
    //electron.ipcRenderer.send('open.devtools');
    log('title.bar: ' + val);
  }
  get systemTitleBar() {
    return localStorage.getItem('systemTitleBar') != 'N';
  }
  blurChange(blur: number): void {
    this.blur = blur;
  }
}
